import { createModel } from "@rematch/core";
import { BigNumber } from "bignumber.js";
import { ERC721__factory } from "../contract/types/ERC721/ethers-contracts/factories/ERC721__factory";
import { ERC721 } from "../contract/types/ERC721/ethers-contracts/ERC721";
import { BigNumber as EthersBigNumber } from "ethers";
import { PROD_CONFIG } from "../const/config";
import { RootModel } from ".";

let Config = PROD_CONFIG;
interface GrantState {
  /** grant总数 */
  MAX_GRANT_MINTS: number;

  /** 每24小时内可grant总数 */
  DAILY_GRANT_MINTS: number;

  /** 已grant的数量 */
  grantMintedNum: number;

  /** 24小时内，已grant的数量 */
  grantDailyMintNum: number;

  /** 24小时的起始时间戳，单位 秒 */
  dailyMintBeginTime: number;

  /** 当前钱包地址是否已经grant */
  grantMints: boolean;

  /** BAYC合约 */
  BAYCContract?: ERC721;

  /** Meebits合约 */
  MeebitsContract?: ERC721;

  /** 检查所有的NFT资格，该变量为 true 时才有资格 Grant */
  AllNFTCheck?: boolean;
}

const initGrantState: GrantState = {
  MAX_GRANT_MINTS: 500,
  DAILY_GRANT_MINTS: 100,
  grantMintedNum: 0,
  grantDailyMintNum: 0,
  dailyMintBeginTime: 0,
  grantMints: false,
};

const ethersBignumberToNumber = (number: EthersBigNumber) => {
  return new BigNumber(number.toString()).toNumber();
};

export const grant = createModel<RootModel>()({
  state: initGrantState,
  reducers: {
    setFields(state, fields: Partial<GrantState>): GrantState {
      return {
        ...state,
        ...fields,
      };
    },
  },
  effects: (dispatch) => ({
    async fetchData(_payload: any, state) {
      const { KungFuHeroContract, userInfo, ethersProvider, signer } =
        state.main;
      if (ethersProvider && signer) {
        // 连接合约
        let BAYCContract = ERC721__factory.connect(Config.BAYC_ARRD, signer);
        dispatch.grant.setFields({
          BAYCContract,
        });
        let MeebitsContract = ERC721__factory.connect(
          Config.MEEBITS_ADDR,
          signer
        );
        dispatch.grant.setFields({
          MeebitsContract,
        });
      }
      if (KungFuHeroContract) {
        const MAX_GRANT_MINTS = await KungFuHeroContract.MAX_GRANT_MINTS();
        const DAILY_GRANT_MINTS = await KungFuHeroContract.DAILY_GRANT_MINTS();
        const grantMintedNum = await KungFuHeroContract.grantMintedNum();
        const grantDailyMintNum = await KungFuHeroContract.grantDailyMintNum();
        const grantMints = await KungFuHeroContract.grantMints(
          userInfo.address
        );
        const dailyMintBeginTime =
          await KungFuHeroContract.dailyMintBeginTime();
        dispatch.grant.setFields({
          MAX_GRANT_MINTS: ethersBignumberToNumber(MAX_GRANT_MINTS),
          DAILY_GRANT_MINTS: ethersBignumberToNumber(DAILY_GRANT_MINTS),
          grantMintedNum: ethersBignumberToNumber(grantMintedNum),
          grantDailyMintNum: ethersBignumberToNumber(grantDailyMintNum),
          dailyMintBeginTime: ethersBignumberToNumber(dailyMintBeginTime),
          grantMints: grantMints,
        });
      }
    },
    async checkAllNFT() {
      let NFTGrantCheck = await Promise.all([
        dispatch.grant.checkNFT({
          NFTType: "Meebits",
        }),
        dispatch.grant.checkNFT({ NFTType: "BAYC" }),
      ]);
      dispatch.grant.setFields({
        AllNFTCheck: NFTGrantCheck.some((check) => check === true),
      });
    },
    async checkNFT(payload: { NFTType: "BAYC" | "Meebits" }, state) {
      let { KungFuHeroContract, userInfo } = state.main;
      let { BAYCContract, MeebitsContract } = state.grant;
      let ERC721Contract;
      if (payload.NFTType === "BAYC") {
        ERC721Contract = BAYCContract;
      } else if (payload.NFTType === "Meebits") {
        ERC721Contract = MeebitsContract;
      } else {
        return false;
      }
      if (ERC721Contract !== undefined && KungFuHeroContract !== undefined) {
        let nftNumber = (
          await ERC721Contract.balanceOf(userInfo.address)
        ).toNumber();
        if (nftNumber === 0) {
          return false;
        }
        let NFTList: number[] = [];
        for (let index = 0; index < nftNumber; index++) {
          let tokenId = (
            await ERC721Contract.tokenOfOwnerByIndex(userInfo.address, index)
          ).toNumber();
          NFTList.push(tokenId);
        }
        let finalResult: boolean[] = [];
        if (payload.NFTType === "Meebits") {
          finalResult = await Promise.all(
            NFTList.map(async (tokenId) => {
              let r = await KungFuHeroContract!.meebitsMints(tokenId);
              return r;
            })
          );
        } else if (payload.NFTType === "BAYC") {
          finalResult = await Promise.all(
            NFTList.map(async (tokenId) => {
              let r = await KungFuHeroContract!.baycMints(tokenId);
              return r;
            })
          );
        }
        return finalResult.every((r) => r === false);
      } else {
        return false;
      }
    },
    async mintWithGrant(_payload, state) {
      const { KungFuHeroContract } = state.main;
      if (KungFuHeroContract) {
        let mintHash;
        try {
          mintHash = await KungFuHeroContract.mintWithGrant();
          if (mintHash) {
            dispatch.main.setTransactionModal({
              open: true,
              status: 0,
              txHash: mintHash.hash,
            });
          }
          let result = await mintHash.wait();
          if (result.status === 1) {
            dispatch.main.setTransactionModal({
              txHash: mintHash.hash,
              open: true,
              status: 1,
            });
          }
          dispatch.grant.fetchData();
        } catch (error) {
          if (error?.code === 4001) {
            // 用户取消连接网站
            dispatch.main.openAlert({
              type: "error",
              content: error.message,
            });
          } else {
            dispatch.main.setTransactionModal({
              txHash: mintHash?.hash,
              open: true,
              status: 2,
              errorMsg: error.message,
            });
          }
        }
      }
    },
  }),
});
